import React from "react";
import NumberFormat, { NumberFormatProps } from "react-number-format";

type InternalFloatFieldProps = Omit<NumberFormatProps, "onChange"> & {
    onChange: (name: string, value: number | undefined) => void;
    name: string;
    value: any,
    decimalScale?: number;
    prefix?: string
}

export function InternalFloatField({ onChange, value, name, decimalScale, prefix, allowNegative, ...props }: InternalFloatFieldProps) {
    const _decimalScale = decimalScale !== undefined ? decimalScale : 2;

    return (
        <NumberFormat 
            {...props}
            value={value || "0"}
            name={name}
            onValueChange={values => {
                if (onChange !== undefined) {
                    onChange(name, values.floatValue);
                }
            }}

            isNumericString
            prefix={prefix}
            allowNegative={false}
            thousandSeparator="."
            decimalScale={_decimalScale}
            decimalSeparator=","
            fixedDecimalScale
        />
    );
}